import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { warehousePermissionUrl } from '.';
import { warehousePermissionsActions } from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { IWarehouseUser } from '../warehousePermissionsInterfaces';

function* updateWarehouseUserSaga(action: ReturnType<typeof warehousePermissionsActions.updateUser>) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(updateWarehouseUser, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(warehousePermissionsActions.setUsers([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateWarehouseUser() {
  yield takeEvery(warehousePermissionsActions.updateUser.match, updateWarehouseUserSaga);
}

export async function updateWarehouseUser(user: IWarehouseUser): Promise<IApiExecuteRespone<IWarehouseUser>> {
  return executeApiRequest(() => httpService.post(warehousePermissionUrl({ departmentId: user.departmentId }), user));
}
